import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IconButton } from '@bingads-webui-react/fabric-control';


export const PlayPauseButtons = React.memo(({
  newI18n, pause, play, isPlaying, customizedClassName,
}) => (
  <div className={classNames('carousel-injected-controls', 'hidden', customizedClassName)}>
    {isPlaying ? <IconButton
      iconProps={{ iconName: 'Pause' }}
      ariaLabel={newI18n.getString(_TL_('Pause the slideshow'))}
      onClick={pause}
    /> : <IconButton
      iconProps={{ iconName: 'Play' }}
      ariaLabel={newI18n.getString(_TL_('Start the slideshow'))}
      onClick={play}
    />}
  </div>
));


export const isPlayPausePreviewImageEnabled = permissions => _.chain(permissions).result('dynamic').result('PlayPausePreviewImage').value();


PlayPauseButtons.propTypes = {
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }),
  pause: PropTypes.func,
  play: PropTypes.func,
  isPlaying: PropTypes.bool,
  customizedClassName: PropTypes.string,
};

PlayPauseButtons.defaultProps = {
  customizedClassName: undefined,
  newI18n: {
    getString: () => {},
  },
  pause: () => {},
  play: () => {},
  isPlaying: false,
};
